
// On desktop we animate the é of écal over scrolling to position of site-nav.
// This requires having a var with scroll position in the DOM

import merge  from '../../fn/stream/merge.js';
import events from '../../dom/modules/events.js';
import rect   from '../../dom/modules/rect.js';
import style  from '../../dom/modules/style.js';
import { px } from '../../dom/modules/parse-length.js';


const sitenav = document.getElementById('navigation');
const pagenav = document.getElementById('page-navigation');

const breakpoint = px('55rem');

merge([null], events('scroll resize', window))
.filter(() => window.innerWidth > breakpoint)
.map(() => rect(pagenav).top < px(style('--nav-height', document.body)))
.reduce((prev, value) => {
    if (prev !== value) {
        sitenav.classList[value ? 'add' : 'remove']('page-nav-stuck');
        pagenav.classList[value ? 'add' : 'remove']('stuck');
    }

    return value;
// Use NaN as a seed as it is not equal to anything
}, NaN);
